<template>
	<div class="equipmentInstallationManagement mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">运营商对账记录</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">对账记录</span>
				</div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.serviceProviderName"
								placeholder="请输入运营商名称"></el-input>
						</div>
						
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.billStatus" slot="prepend" placeholder="请选择运营状态">
								<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="开始时间">
							</el-date-picker>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="结束时间">
							</el-date-picker>	
							<!-- <el-date-picker v-model="searchObj.searchData" type="daterange" range-separator="~"
								value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker> -->
						</div>
						<el-button type="success" @click="toSearch(1)">查询</el-button>
					</div>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>
			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData1" stripe style="width: 100%">
							<el-table-column type="index" label="序号" width="60">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="serviceProviderName" label="运营商名称">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="serviceProviderType" label="运营商类型">
								<template slot-scope="scope">
									<span>{{getName(scope.row.serviceProviderType,stypeList)}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="settlementCycle" label="结算周期">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="settlementTime" label="结算日期">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="totalRevenueAmount" label="总营收金额(元)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="profitAmount" label="利润金额(元)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="divideAccountType" label="分账方式">
								<template slot-scope="scope">
									<span>{{getName(scope.row.divideAccountType,dtypeList)}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="divideAccountProportion" label="分账比例">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="shareAmount" label="分账金额">
							</el-table-column>
							<el-table-column prop="billStatus" label="打款状态">
								<template slot-scope="scope">
									<span>{{getName(scope.row.billStatus,statusList)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="operate" width="180" label="操作" fixed="right">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">账单详情</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">打款详情</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,3)">去处理</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="打款详情" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogVisible"
			width="40%">
			<div class="dialogBox3">
				<div class="titleBox">{{creatObj.settlementCycle}}</div>
				<div class="contBox">
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">打款金额:</span>
							<span class="valueBox">{{creatObj.shareAmount}}元</span>
						</div>
						<div class="elBox">
							<span class="nameBox">打款方:</span>
							<span class="valueBox">{{creatObj.repairUserId}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">打款状态:</span>
							<span class="valueBox">{{getName(creatObj.billStatus,statusList)}}</span>
						</div>
						<div class="elBox ">
							<span class="nameBox">失败原因:</span>
							<span class="valueBox">
								{{creatObj.failReason}}
							</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">收款账户:</span>
							<span class="valueBox">{{creatObj.accountNumber}}</span>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="账单详情" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow"
			width="95%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disBetween">
					<div class="myinputBox">
						<el-select clearable v-model="OperationObj.communityName" allow-create filterable remote
							reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod" @change="changeSelect">
							<el-option v-for="item in restaurants" :key="item.communityId" :label="item.communityName"
								:value="item.communityId">
							</el-option>
						</el-select>
					</div>
					<div class="myinputBox ">
						<el-select clearable v-model="OperationObj.communitySiteId" slot="prepend" placeholder="请选择充电站">
							<el-option v-for="(item,inx) in stationList" :key="inx" :label="item.communitySiteName"
								:value="item.communitySiteId"></el-option>
						</el-select>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="OperationObj.communityEquipmentNo"
							placeholder="请输入设备编号"></el-input>
					</div>
					<el-button type="success" @click="toSearch(2)">查询</el-button>
				</div>

				<div class="myTable" v-loading="loading2">
					<el-table :data="tableData2" style="width: 100%">
						<el-table-column type="index" label="序号" width="60">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="startTime" label="充电时间" width="140">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value2" label="用户名">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentName" label="设备名称">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentName" label="端口">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communitySiteName" label="所属站点">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="orderStatus" label="充电情况">
							<template slot-scope="scope">
								<span>{{scope.row.orderStatus==1?"正常":scope.row.orderStatus==2?"故障":scope.row.orderStatus==3?"离线":""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="orderAmount" label="充电金额(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeTime" label="充电时长">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="returnConsumeAmount" label="退款(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="realConsumeAmount" label="实际营收(元)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value6" label="用电量(kWh)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="value6" label="利润(元)">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange($event,2)">
					</el-pagination>
				</div>

			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../assets/js/common.js"
	var token = localStorage.getItem('token')
	export default {
		name: "accountManage",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {
					billStatus: ""
				},
				accountsObj: {},
				dialogVisible: false,
				visibleShow: false,
				NOfalse: false,
				stationList: [],
				restaurants: [],
				options: [],
				stypeList: [{
						text: "直营商",
						value: 1
					},
					{
						text: "承包商",
						value: 2
					},
					{
						text: "第三方",
						value: 3
					},
				],
				dtypeList: [{
						text: "利润",
						value: 1
					},
					{
						text: "流水",
						value: 2
					}
				],
				statusList: [{
						text: "未结算",
						value: 0
					}, {
						text: "未打款",
						value: 1
					},
					{
						text: "打款中",
						value: 2
					},
					{
						text: "打款成功",
						value: 3
					}, {
						text: "打款失败",
						value: 4
					}
				],
				tableData1: [],
				tableData2: [],
				loading: false,
				loading2: false,
				searchObj: {
					billStatus: "",
					endTime: "",
					startTime: "",
					serviceProviderName: "",
					pageNo: 1, //当前页
					pageSize: 8, //当前页个数
					searchData: []
				},
				OperationObj: {
					communityName: "",
					communitySiteId: "",
					endTime: "",
					pageNo: 1,
					pageSize: 8,
					search: "",
					serviceProviderId: "",
					startTime: "",
				},
				OperationInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
			}
		},
		mounted() {
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			this.$nextTick(() => {
				this.getData1()
			})
		},
		methods: {
			changeSelect(n) {
				this.$set(this, "stationList", [])
				this.$set(this.OperationObj, "communitySiteId", "")
				this.$set(this.OperationObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.OperationObj, "communityName", item.communityName)
					if (n) {
						this.$api.listAllCommunitySiteByCommunityId({
							communityId: item.communityId
						}).then((res) => {
							if (res.returnCode == 200) {
								this.$set(this, "stationList", res.obj)
							}
						})
					}
				} else {
					this.$set(this.OperationObj, "communityName", n)
				}
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			goUrl(obj) {
				console.log(obj)
				this.$router.push({
					path: '/businessPowerManange',
					query: obj
				});
				this.$emit("setPath", "/businessPowerManange")
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			exportData() {
				this.$api.exportServiceProviderBill(this.searchObj, "对账列表").then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			itemClick(item, n) {
				let that = this
				console.log(item)
				if (n == 1) {
					this.$set(this, "creatObj", item)
					this.dialogVisible = true
				} else if (n == 2) {
					this.getData2()
					this.visibleShow = true
				} else if (n == 3) {
					this.visibleShow = true
					this.goUrl(item)
				}
			},
			toSearch(n) {
				if (n == 1) {
					this.$set(this.PageInfo,"pagenum",1)
					this.$set(this.searchObj,"pageNo",1)
					this.$nextTick(() => {
						this.getData1()
					})
				} else {
					this.$set(this.OperationInfo,"pagenum",1)
					this.$set(this.OperationObj,"pageNo",1)
					this.$nextTick(() => {
						this.getData2()
					})
				}

			},
			getData1() {
				this.loading = true
				this.$api.listServiceProviderBill(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData1", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})

			},
			getData2() {
				this.loading2 = true
				let obj = {
					pageNo: this.OperationObj.pageNo, //当前页
					pageSize: this.OperationObj.pageSize, //当前页个数
					communityName: this.OperationObj.communityName,
					communitySiteId: this.OperationObj.communitySiteId,
					search: this.searchObj.search, //用户名称
					communityEquipmentNo: this.OperationObj.communityEquipmentNo, 
					startTime: this.searchObj.startTime, //开始时间
					endTime: this.searchObj.endTime, //结束时间
				}
				console.log(obj)
				this.$api.listRechargeRecord(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						this.$set(this, "tableData2", res.obj.list || [])
						this.$set(this.OperationInfo, "total", res.obj.total || 0)
					}
				})
			},
			// 选择分页
			handleCurrentChange(val,n) {
				if(n==1){
					this.$set(this.PageInfo,"pagenum",val)
					this.$set(this.searchObj,"pageNo",val)
					this.getData1()
				}else{
					this.$set(this.OperationInfo,"pagenum",val)
					this.$set(this.OperationObj,"pageNo",val)
					this.getData2()
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./reconciliationRecords.scss";
</style>